<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  activeId: {
    type: [Number, String, null],
    default: null
  }
})

const emit = defineEmits(['item-click'])

const scrollContainer = ref(null)
const showLeftButton = ref(false)
const showRightButton = ref(false)

const scrollLeft = () => {
  scrollContainer.value?.scrollBy({ left: -200, behavior: 'smooth' })
}

const scrollRight = () => {
  scrollContainer.value?.scrollBy({ left: 200, behavior: 'smooth' })
}

const updateScrollButtons = () => {
  if (scrollContainer.value) {
    const scrollLeftVal = scrollContainer.value.scrollLeft
    const maxScrollLeft = scrollContainer.value.scrollWidth - scrollContainer.value.clientWidth
    showLeftButton.value = scrollLeftVal > 0
    showRightButton.value = scrollLeftVal < maxScrollLeft
  }
}

onMounted(() => {
  updateScrollButtons()
  scrollContainer.value?.addEventListener('scroll', updateScrollButtons)
})
watch(
  () => props.items,
  async () => {
    await nextTick() 
    updateScrollButtons()
  },
  { immediate: true, deep: true }
)
</script>

<template>
  <div class="relative flex items-center w-full max-w-full">
    <button
      v-if="showLeftButton"
        class="absolute left-[-8px] top-1/2 -translate-y-1/2 z-10 h-full bttns bttn-prev"
      @click="scrollLeft"
    >
      <slot name="left-icon">
        <img src="/chevron-left.svg" class="w-5 h-5" />
      </slot>
    </button>

    <div
      ref="scrollContainer"
      class="flex overflow-x-auto scrollbar-hide w-full max-w-full"
    >
      <slot
        v-for="item in items"
        :name="'item'"
        :item="item"
      >
        <button
          :key="item.id"
          @click="$emit('item-click', item.id)"
          class="p-2 bg-gray-200 rounded whitespace-nowrap"
        >
          {{ item.title }}
        </button>
      </slot>
    </div>

    <button
      v-if="showRightButton"
      class="absolute right-[-8px] top-1/2 -translate-y-1/2 z-5  h-full bttns bttn-next"
      @click="scrollRight"
    >
      <slot name="right-icon">
        <img src="/chevron-right.svg" class="w-5 h-5" />
      </slot>
    </button>
  </div>
</template>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.bttns{
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(4px);
}
.bttn-prev{
    background: linear-gradient(-90deg, transparent, rgba(40,40,40,0.9) 14px);
}
.bttn-next{
    background: linear-gradient(90deg, transparent, rgba(40,40,40,0.9) 14px);
}
</style>
